import type { User } from '../../@types/global';
import { AppType, UserRole } from '../../@types/global';

export const hasNoValidLocations = (user: any) => {
  const hasUserBeenFetched = !!user?.userRole;
  const hasNoLocations = !user?.organizations?.length;
  const hasNoPractices = !user?.organizations?.find(
    (organization: any) => organization.practiceId,
  );

  return (
    hasUserBeenFetched &&
    (hasNoLocations || (hasNoPractices && !isDirectorUser(user)))
  );
};

export const isDirectorUser = (user?: User): boolean => {
  return Boolean(
    user &&
      user.userRole &&
      user.userRole.toLowerCase() === UserRole.DENTAL_DIRECTOR.toLowerCase(),
  );
};

export const isMultiPracticeUser = (user?: User): boolean => {
  return Boolean(
    isDirectorUser(user) ||
      (user?.organizations && user?.organizations.length > 1),
  );
};

// Function use to return application name
export const getAppName = (userRole: any) =>
  userRole === UserRole.DENTAL_DIRECTOR
    ? AppType.VIDEA_INSIGHT
    : AppType.VIDEA_ASSIST;
